import * as React from 'react';
import { AnalyticsTrigger, Anchor, GridColumn, Image, Separator, Tag, TGridColumnWidth } from 'telia-front-react';
import { DigitarkNewsItem } from '../stores/DigitarkNewsStore';

interface DigiTarkNewsCardB2BProps extends DigitarkNewsItem {
  grid?: TGridColumnWidth[];
}

const DigiTarkNewsCardB2B: React.FC<DigiTarkNewsCardB2BProps> = (props) => {
  const srcset = ['380', '760']
    .map((size) => {
      return `https://res.cloudinary.com/telia/image/fetch/ar_2,w_ow,c_crop,g_faces,f_auto,fl_lossy,q_auto:best/w_${size},r_3/${props.feedImageUrl} ${size}w`;
    })
    .join(',');

  return (
    <GridColumn width={props.grid}>
      <AnalyticsTrigger trigger={{ id: `Link - ${props.originalTitle}`, callback: 'onClick' }}>
        <Anchor url={props.link}>
          <Image role="presentation" srcset={srcset} style={{ borderRadius: '3px' }} />
        </Anchor>
        <Separator spacing="xxsmall" color="invisible" />
        {props.categories.map((category) => (
          <React.Fragment key={`${category}-${props.id}`}>
            <Anchor url={category.link} isUnderlined={false}>
              <Tag key={category.id} text={category.name} size="tiny" />{' '}
            </Anchor>
          </React.Fragment>
        ))}
        <Separator spacing="xxsmall" color="invisible" />
        <Anchor url={props.link} isUnderlined={false} isTextColor={true} className="text-weight-normal">
          <h4>{props.originalTitle}</h4>
        </Anchor>
      </AnalyticsTrigger>
    </GridColumn>
  );
};

DigiTarkNewsCardB2B.defaultProps = {
  grid: ['xs-12', 'sm-6', 'md-4'],
};

export default DigiTarkNewsCardB2B;
